import "./GlJournal.scss";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomButtonSmall,
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import { fetchClientsBySearch, fetchMainLedgers, fetchSubLedgers, formatAmountsToDecimals, formatNumber, formatStringToNumberV2, logData, numberToWordsWithDecimal } from "../../../utils/genericFunctions.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination
} from "@mui/material";
import DOMPurify from 'dompurify';
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import Badge from '@mui/material/Badge';
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useRef, useState, useMemo, } from "react";
import Confetti from "react-confetti";
import { IoChatbubbles, IoCheckmarkDoneSharp, IoClose, IoDocumentTextSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { ScaleLoader } from "react-spinners";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import TagIcon from '@mui/icons-material/Tag';
import { TbCertificate } from "react-icons/tb";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import HRHandbook from "../../../components/test/HRHandbook.jsx";
import { useTranslation } from "react-i18next";
import { MdAdd, MdAlternateEmail, MdClose, MdDelete, MdEdit, MdEditDocument, MdForum, MdPhone, MdRefresh, MdSave, MdSms } from "react-icons/md";
import Taccount from "../../../components/taccount/Taccount.jsx";
import { RiAttachment2 } from "react-icons/ri";
import { HiOutlineLink } from "react-icons/hi2";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import { CustomRadioGroup } from "../../../components/radio/CustomRadioGroup.jsx";
import Collaborator from "../../../components/Collaborator/Collaborator.jsx";


const GlJournal = () => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);

  const [isCollabOpen, setIsCollabOpen] = useState(false);
  const openCollab = () => setIsCollabOpen(true);
  const closeCollab = () => setIsCollabOpen(false);
  const pageShellRef = useRef(null);
  const [collabRightOffset, setCollabRightOffset] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const navigate = useNavigate();
  const [journalData, setJournalData] = useState(null);
  const [figuresToShow, setFiguresToShow] = useState("org");
  const { docid } = useParams();
  const [journalDocId, setJournalDocId] = useState(null);
  const journalTypeRef = useRef(null);
  const mainLedgerRef = useRef(null);

  const glDateRef = useRef(null);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [nextAction, setNextAction] = useState("Validate");
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [numGeneration, setNumGeneration] = useState({});
  let generatedDocNo = "";
  let isDocumentNumberSetup = false;
  const [hdNo, setHdNo] = useState(null);

  const [hdCurCode, setHdCurCode] = useState({
    value: "",
    label: "",
  });
  const [traceData, setTraceData] = useState([]);
  const [hdCurRate, setHdCurRate] = useState(1);
  const [currencies, setCurrencies] = useState([]);
  const [hdNarration, setHdNarration] = useState(null);
  const [hdRefNo, setHdRefNo] = useState(null);
  const [hdType, setHdType] = useState({
    value: "Normal",
    label: "Normal",
  });
  const [hdBizUnit, setHdBizUnit] = useState(null);
  const [branches, setBranches] = useState([]);
  const [hdGlDate, setHdGlDate] = useState(null);
  const [hdMode, setHdMode] = useState(null);
  const [hdStatus, setHdStatus] = useState("New");
  const [hdSource, setHdSource] = useState(null);

  const [attachmentsData, setAttachmentsData] = useState([]);
  const investorRef = useRef(null);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [journalLines, setJournalLines] = useState([]);
  const [selectedJournalLine, setSelectedJournalLine] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);

  const [totalDebitFc, setTotalDebitFc] = useState(0);
  const [totalDebitLc, setTotalDebitLc] = useState(0);
  const [totalCreditFc, setTotalCreditFc] = useState(0);
  const [totalCreditLc, setTotalCreditLc] = useState(0);
  const [controlAmountFc, setControlAmountFc] = useState(0);
  const [controlAmountLc, setControlAmountLc] = useState(0);

  const [journalSources, setJournalSources] = useState([]);
  const [journalTypes, setJournalTypes] = useState([]);
  const [drcrFlags, setDrcrFlags] = useState([
    {
      value: "D",
      label: "Debit"
    }, {
      value: "C",
      label: "Credit"
    }
  ]);

  const [isLedgerDialogOpened, setIsLedgerDialogOpened] = useState(false);
  const [ledgerAction, setLedgerAction] = useState("");
  const [mainLedger, setMainLedger] = useState(null);
  const [mainLedgerType, setMainLedgerType] = useState(null);
  const [subLedger, setSubLedger] = useState(null);
  const [flag, setFlag] = useState(null);
  const [fcAmount, setFcAmount] = useState(0);
  const [lcAmount, setLcAmount] = useState(0);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentPage(0);
  };

  const slicedJournalLines = journalLines.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );


  const fetchTrace = async (journalNo) => {
    try {
      const res = await newRequest.post(
        "/trace/findDoc",
        {
          trc_doc_type: "Gl Journal",
          trc_doc_no: journalNo
        }
      );
      setTraceData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  const handleCurRateBlur = (e) => {
    try {
      if (e.target.value) {
        // const strippedValue = e.target.value.replace(/,/g, "");
        // if (isNaN(strippedValue)) {
        //   setNotifyDialogTitle("Error!");
        //   setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
        //   setIsNotifyDialogOpen(true);
        //   return;
        // }
        // setHdCurRate(formatAmountsToDecimals(strippedValue, 4));
        // const lcAmount = Number(parseFloat(hdFcAmount * formatAmountsToDecimals(strippedValue, 4)).toFixed(4));
        // setHdLcAmount(lcAmount);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleGlDateChange = async (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setHdGlDate(formattedGlDate);
        if (hdCurCode.value !== currentUser?.currency_code_xx) {

          // console.log(`curRate  ${JSON.stringify(curRate, null, 2)}`);
          // get rate
          const res = await newRequest.post("/glCurrencyRate/find", {
            rate_cur_code_fm: hdCurCode.value,
            rate_cur_code_to: currentUser?.currency_code_xx,
            rate_date: formattedGlDate,
          });
          if (!res.data || !res.data?.rate) {
            setHdCurCode({
              value: currentUser.currency_code_xx,
              label: currentUser.currency_name_xx,
            });
            setHdCurRate(1);
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(
              `Conversion Rate from <strong>${hdCurCode.value
              } to ${currentUser.currency_code_xx
              } for date ${moment(hdGlDate).format(
                "DD-MMM-YYYY"
              )}</strong> NOT found. Currency will reset to <strong>${currentUser.currency_code_xx
              }</strong>`
            );
            setIsNotifyDialogOpen(true);
          } else {
            setHdCurRate(res.data.rate);
          }
        } else {
          setHdCurRate(1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchJournal = async (doc_id, firstTime = false) => {
    try {
      if (doc_id && doc_id !== "new") {
        if (firstTime) {
          setIsLoading(true);
        }
        const res = await newRequest.get(`/glJournal/findWithLines/${doc_id}`);

        if (res.data) {
          setJournalData(res.data);
          setJournalDocId(res.data._id);

          if (res.data?.hd_no) {
            setHdNo(res.data?.hd_no);
          }

          if (res.data?.hd_status) {
            setHdStatus(res.data?.hd_status);
          }

          if (res.data?.hd_cur_rate) {
            setHdCurRate(res.data?.hd_cur_rate);
          }
          if (res.data?.hd_narration) {
            setHdNarration(res.data?.hd_narration);
          }
          if (res.data?.hd_ref_no) {
            setHdRefNo(res.data?.hd_ref_no);
          }

          if (res.data?.hd_type) {
            setHdType({
              value: res.data?.hd_type,
              label: res.data?.hd_type_xx,
            });
          }

          if (res.data?.hd_biz_unit) {
            setHdBizUnit({
              value: res.data?.hd_biz_unit,
              label: res.data.bizunit_name_xx,
            });
          }

          if (res.data?.hd_gl_date) {
            const formattedGlDate = moment(res.data?.hd_gl_date).format(
              "YYYY-MM-DD"
            );
            setHdGlDate(formattedGlDate);
          }

          if (res.data?.hd_cur_code) {
            setHdCurCode({
              value: res.data?.hd_cur_code,
              label: res.data?.hd_cur_code,
            });
          }

          if (res.data?.hd_source) {
            setHdSource({
              value: res.data?.hd_source,
              label: res.data?.hd_source_xx,
            });
          }

          const formattedLines = res.data?.journal_lines_xx?.map(line => ({
            ...line,
            ln_amount_fc: formatAmountsToDecimals(line?.ln_amount_fc || 0),
            ln_amount_lc: formatAmountsToDecimals(line?.ln_amount_lc || 0),
          }));
          setJournalLines(formattedLines);

          setDocumentEnabled(res.data.document_enabled_xx);
          setNextAction(res.data.next_action_xx);
          await fetchTrace(res.data?.hd_no);
        }
        fetchDocumentAttachments("Gl Journal", res.data._id);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (firstTime) {
        setIsLoading(false);
      }
    }
  };

  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      const options = res.data.map((branch) => ({
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));
      setBranches(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      const options = res.data.map((currency) => ({
        value: currency.cur_code,
        label: currency.cur_name,
      }));
      setCurrencies(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchNumberGeneration = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/find", { gen_type: "Journal" },);
      setNumGeneration(res.data);
      isDocumentNumberSetup = true;
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDocumentAttachments = async (docType, docid) => {
    try {
      const res = await newRequest.post(
        "/files/findDocFiles",
        {
          fl_doc_type: docType,
          fl_parent_doc_id: docid,
        },

      );

      setAttachmentsData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const callDetailsFunction = async () => {
    try {
      await fetchCurrencies();
      await fetchBranches();
      await fetchJournalSources();
      await fetchJournalTypes();
    } catch (err) {
      console.log(err);
    }
  };

  const fetchJournalSources = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Journal Sources" });
      const options = res.data.map((row) => ({
        value: row?.sys_code,
        label: row?.sys_name,
      }));
      setJournalSources(options);
    } catch (error) {
      console.error("Error fetching journal sources :", error);
    }
  };

  const fetchJournalTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Journal Types" });
      const options = res.data.map((row) => ({
        value: row?.sys_code,
        label: row?.sys_name,
      }));
      setJournalTypes(options);
    } catch (error) {
      console.error("Error fetching journal types :", error);
    }
  };

  // generate document number
  const generateDocumentNo = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/gen", { gen_type: "Journal", },);
      generatedDocNo = res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfettiClick = () => {
    setIsConfettiActive(true);
    // Set a timeout to stop the confetti after a few seconds (optional)
    setTimeout(() => {
      setIsConfettiActive(false);
    }, 5000); // Stop confetti after 3 seconds
  };

  const handleConfirm = async () => {
    setIsConfirmDialogOpen(false);

    try {
      if (["validateJournal", "approveJournal"].includes(confirmDialogAction)) {
        if (controlAmountFc !== 0) {
          setNotifyDialogTitle(t("error"));
          setNotifyDialogText(
            t("drcrError", {
              param1: numeral(totalDebitFc).format('0,0.00'),
              param2: numeral(totalCreditFc).format('0,0.00'),
              param3: numeral(controlAmountFc).format('0,0.00'),
            })
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        setIsProcessing(true);

        const formattedGlDate = moment(hdGlDate).format("YYYY-MM-DD");
        const res = await newRequest.post("/glCp/periodStatus", {
          cp_cy_type: "Financial",
          gl_date: formattedGlDate,
        });

        if (!res.data?.cp_status) {
          setConfirmDialogAction("None");
          setNotifyDialogTitle(t("note"));
          setNotifyDialogText("Check GL Date");
          setIsNotifyDialogOpen(true);

          if (glDateRef.current) {
            glDateRef.current.focus();
          }
          return;
        }

        if (res.data?.cp_status === "Closed") {
          setConfirmDialogAction("None");
          setNotifyDialogTitle(t("note"));
          setNotifyDialogText(
            `Accounting date ${moment(hdGlDate).format("DD-MMM-YYYY")} is within Financial period ${res.data.cp_code
            }. The period is ${res.data.cp_status}. You cannot proceed.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        let validateResponse;
        try {
          validateResponse = await newRequest.get(`/glJournal/validate/${journalDocId}`, {
            timeout: 100000,
          });
        } catch (error) {
          if (error.code === "ECONNABORTED") {
            console.error("Request timed out!");
            showToast(t("requestTimedOut"), "error");
          } else {
            console.error("Other error:", error.message);
            showToast(error.message, "error");
          }
          return;
        }

        if (validateResponse?.data?.result_status === "error") {
          setValidationMessagesResult(validateResponse.data);
          setValidationMsgDialog(true);
          return;
        }

        await newRequest.put(`/glJournal/upd/${journalData._id}`, {
          hd_status: objectToAction?.new_doc_status,
        });

        await fetchJournal(journalDocId);

        setConfirmDialogAction("None");
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`Journal successfully ${objectToAction?.new_doc_status}`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (confirmDialogAction === "cancelJournal") {
        setIsProcessing(true);

        let validateResponse;
        try {
          validateResponse = await newRequest.get(`/glJournal/reverse/${journalDocId}`, {
            timeout: 100000,
          });
        } catch (error) {
          if (error.code === "ECONNABORTED") {
            console.error("Request timed out!");
            showToast(t("requestTimedOut"), "error");
          } else {
            console.error("Other error:", error.message);
            showToast(error.message, "error");
          }
          return;
        }

        if (validateResponse?.data?.result_status === "error") {
          setConfirmDialogAction("None");
          setValidationMessagesResult(validateResponse.data);
          setValidationMsgDialog(true);
          return;
        }

        await newRequest.put(`/glJournal/upd/${journalData._id}`, {
          hd_status: objectToAction?.new_doc_status,
        });

        await fetchJournal(journalDocId);

        setConfirmDialogAction("None");
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`Journal successfully ${objectToAction?.new_doc_status}`);
        setIsNotifyDialogOpen(true);
      } else if (confirmDialogAction === "voidJournal") {
        setIsProcessing(true);
        try {
          const res = await newRequest.put(`/glJournal/upd/${journalData._id}`, { hd_status: "Voided" });
          setIsProcessing(false);
          if (res.data.msg === "updated") {
            await fetchJournal(journalDocId);
            showToast(t('documentVoided', { param1: hdNo }), "success");
          } else {
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(res.data?.text);
            setIsNotifyDialogOpen(true);
          }
        } catch (error) {
          setIsProcessing(false);
          console.log(error);
        }
      }
    } catch (err) {
      console.log(err);
      showToast(err?.message || "An unexpected error occurred", "error");
    } finally {
      setIsProcessing(false);
    }
  };


  const saveRecord = async (e) => {
    try {


      if (!hdSource?.value) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please enter source!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdGlDate) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please enter GL Date!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdType?.value) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please select type!`);
        setIsNotifyDialogOpen(true);
        if (journalTypeRef.current) {
          journalTypeRef.current.focus();
        }
        return;
      }

      if (journalDocId === "new" && !hdNo) {
        await generateDocumentNo();
      }

      setIsProcessing(true);
      //prepare data
      const journalHeader = {
        hd_org_code: currentUser.usr_org_code,
        hd_no: hdNo || generatedDocNo,
        hd_narration: hdNarration || "",
        hd_ref_no: hdRefNo || "",
        hd_type: hdType?.value,
        hd_biz_unit: hdBizUnit?.value,
        hd_gl_date: hdGlDate,
        hd_cur_code: hdCurCode?.value,
        hd_cur_rate: hdCurRate,
        hd_source: hdSource?.value,
        hd_status: hdStatus
      };

      if (journalDocId === "new") {
        const res = await newRequest.post("/glJournal/add", journalHeader);
        setHdNo(generatedDocNo);
        setIsProcessing(false);
        setNotifyDialogTitle(t('success'));
        setNotifyDialogText(t('successSaved', { param1: generatedDocNo }));
        setIsNotifyDialogOpen(true);
        await fetchJournal(res.data?.doc?._id);
        navigate(`/journal/${res.data?.doc?._id}`, { replace: true });
      } else {
        // save changed lines
        // const changedLines = journalLines?.filter(  (obj) => obj.changed_xx === "Y" );
        const changedLines = journalLines;
        for (let i = 0; i < changedLines.length; i++) {
          const lcAmount = Number(parseFloat(formatStringToNumberV2(changedLines[i].ln_amount_fc) * hdCurRate).toFixed(4));
          await newRequest.put(
            `/glJournal/updLine/${changedLines[i]._id}`,
            {
              ln_amount_fc: parseFloat(formatStringToNumberV2(changedLines[i].ln_amount_fc || 0)),
              ln_amount_lc: parseFloat(formatStringToNumberV2(lcAmount || 0)),
            }
          );
        }
        await newRequest.put(`/glJournal/upd/${journalDocId}`, journalHeader);
        setNotifyDialogTitle(t('success'));
        setNotifyDialogText(t('successSaved', { param1: hdNo || generatedDocNo }));
        setIsNotifyDialogOpen(true);
        setIsProcessing(false);
      }
    } catch (err) {
      setIsProcessing(false);
      console.log(err);
    }
  };


  const handleTabClick = (index) => {
    setActiveTab(index);
  };


  const [activeTab, setActiveTab] = useState(0);

  function getMenuTitle(menuKey) {
    switch (menuKey) {
      case 'details':
        return t('details');
      case 'attachments':
        return t('attachments');
      case 'correspondence':
        return t('correspondence');
      case 'comments':
        return t('comments');
      default:
        return '';
    }
  }

  const topMenus = [
    {
      menu_key: "details",
      menu_title: getMenuTitle("details"),
      menu_icon: <MdEditDocument />,
      menu_count: 0,
    },
    {
      menu_key: "attachments",
      menu_title: getMenuTitle("attachments"),
      menu_icon: <RiAttachment2 />,
      menu_count: attachmentsData.length,
    },
    {
      menu_key: "correspondence",
      menu_title: getMenuTitle("correspondence"),
      menu_icon: <MdSms />,
      menu_count: 0,
    },
    {
      menu_key: "comments",
      menu_title: getMenuTitle("comments"),
      menu_icon: <IoChatbubbles />,
      menu_count: 0,
    },
  ];


  const handleLineInputChange = (e, id, field) => {
    try {
      const newData = [...journalLines];
      const index = newData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        if (e && e.target) {
          // Regular input
          newData[index][field] = e.target.value;
        } else if (e && typeof e === "object") {
          // react-select returns the whole selected option object
          newData[index][field] = e.value;
        }
        newData[index]["flag_xx"] = "new";
        setJournalLines(newData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLineBlur = (id, field) => {
    try {
      const updatedData = [...journalLines];
      const index = updatedData.findIndex(smi => smi._id === id);

      if (index !== -1) {
        let value = updatedData[index][field];
        const numberFields = ["ln_amount_fc"];

        if (numberFields.includes(field)) {
          let fcAmount = parseFloat(formatStringToNumberV2(value || 0));
          const lcAmount = Number(parseFloat(fcAmount * hdCurRate).toFixed(4));
          updatedData[index][field] = formatAmountsToDecimals(value);
          updatedData[index]["ln_amount_lc"] = formatAmountsToDecimals(lcAmount);
        } else {
          updatedData[index][field] = value;
        }

        setJournalLines(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    const compute = () => {
      const el = pageShellRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      // how much “empty space” exists on the right side of the centered/max-width container
      const offset = Math.max(0, window.innerWidth - rect.right);
      setCollabRightOffset(offset);
    };

    compute();

    window.addEventListener("resize", compute);
    // optional: if your layout can shift on scroll due to sticky headers etc.
    window.addEventListener("scroll", compute, true);

    return () => {
      window.removeEventListener("resize", compute);
      window.removeEventListener("scroll", compute, true);
    };
  }, []);


  // calculate total allocation
  useEffect(() => {
    if (!Array.isArray(journalLines)) return;

    let fcDebitTotal = 0;
    let lcDebitTotal = 0;
    let fcCreditTotal = 0;
    let lcCreditTotal = 0;

    for (const item of journalLines) {
      if (item?.ln_drcr_flag === "D") {
        const fc = parseFloat(formatStringToNumberV2(item?.ln_amount_fc || 0)) || 0;
        const lc = parseFloat(formatStringToNumberV2(item?.ln_amount_lc || 0)) || 0;
        fcDebitTotal += isNaN(fc) ? 0 : fc;
        lcDebitTotal += isNaN(lc) ? 0 : lc;
      } else if (item?.ln_drcr_flag === "C") {
        const fc = parseFloat(formatStringToNumberV2(item?.ln_amount_fc || 0)) || 0;
        const lc = parseFloat(formatStringToNumberV2(item?.ln_amount_lc || 0)) || 0;
        fcCreditTotal += isNaN(fc) ? 0 : fc;
        lcCreditTotal += isNaN(lc) ? 0 : lc;
      }
    }

    setTotalDebitFc(fcDebitTotal);
    setTotalDebitLc(lcDebitTotal);
    setTotalCreditFc(fcCreditTotal);
    setTotalCreditLc(lcCreditTotal);
    setControlAmountFc(fcDebitTotal - fcCreditTotal);
    setControlAmountLc(lcDebitTotal - lcCreditTotal);
  }, [journalLines]);

  useEffect(() => {
    if (isLedgerDialogOpened) {
      if (mainLedgerRef.current) {
        mainLedgerRef.current.focus();
      }
    }
  }, [isLedgerDialogOpened]);


  useEffect(() => {
    if (docid) {
      setJournalDocId(docid);
    }
  }, [docid]);


  useEffect(() => {
    // fetch number generation to check if its auto or manual
    fetchNumberGeneration();

    //if receipt is selected, use journalDocId to get quote details
    //if its new record, no fetch is necessary

    if (journalDocId === "new" || journalDocId === undefined) {
      setJournalDocId("new");
      setDocumentEnabled("Y");
      // // set gl date
      const currentDate = new Date();
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      setHdGlDate(formattedCurrentDate);
      // set defult business unit
      setHdBizUnit({
        value: currentUser?.biz_unit_code_xx,
        label: currentUser?.biz_unit_name_xx,
      });
      // set default currency
      setHdCurCode({
        value: currentUser?.currency_code_xx,
        label: currentUser?.currency_code_xx,
      });

      if (journalTypeRef.current) {
        journalTypeRef.current.focus();
      }
    } else {
      fetchJournal(journalDocId, true);
    }
    callDetailsFunction();
  }, [journalDocId]);


  return (
    <motion.div
      className="gl-journal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="gl-journal-main-wrapper" ref={pageShellRef}>
          <div className="gl-journal-navbar">
            <div className="gl-journal-navbar-left">
              <span className="page-title"> {hdNo || t('newJournal')}</span>
              <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${hdType?.label} [${hdStatus}]`}</span>
            </div>
            <div className="gl-journal-navbar-right">

              {journalDocId !== "new" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<MdRefresh />}
                  onClick={async () => { await fetchJournal(journalDocId) }}
                >
                  {t('refresh')}
                </CustomLoadingButton>
              )}
              {journalDocId !== "new" && nextAction !== "None" && (
                <>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="EDE9FE"
                    color="#fbbf24"
                    endIcon={<DragIndicatorIcon />}
                    onClick={() => {
                      try {
                        // console.log(`Status is ${hdStatus}`);
                        let action_text = "";
                        let new_doc_status = hdStatus;
                        switch (hdStatus) {
                          case "New":
                            action_text = `Do you want to Validate ${hdNo}?`;
                            setInvokedAction("Validate");
                            new_doc_status = "Validated";
                            setConfirmDialogAction("validateJournal");
                            break;
                          case "Validated":
                            action_text = `Do you want to Approve ${hdNo}?`;
                            setInvokedAction("Approve");
                            new_doc_status = "Approved";
                            setConfirmDialogAction("approveJournal");
                            break;
                          case "Approved":
                            action_text = `Do you want to cancel ${hdNo}?`;
                            setInvokedAction("Cancel");
                            new_doc_status = "Cancelled";
                            setConfirmDialogAction("cancelJournal");
                            break;
                          default:
                            action_text = "";
                            new_doc_status = "";
                            setConfirmDialogAction("none");
                        }
                        setObjectToAction({
                          object_id: journalData._id,
                          action_text: action_text,
                          new_doc_status,
                        });
                        setIsConfirmDialogOpen(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    {nextAction}
                  </CustomLoadingButton>
                </>
              )}
              {documentEnabled === "Y" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#00D37F"
                  tooltip="Save changes"
                  endIcon={<MdSave />}
                  onClick={saveRecord}>
                  {t('save')}
                </CustomLoadingButton>
              )}
              {journalDocId !== "new" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run reports for this document"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
              )}
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#f55656"
                tooltip="Close this document"
                endIcon={<MdClose />}
                onClick={() => navigate(-1)}>
                {t('close')}
              </CustomLoadingButton>
              {journalDocId !== "new" && (
                <div className="collaborator-icon"
                  onClick={openCollab}>
                  <MdForum className="icon" />
                </div>
              )}
            </div>
          </div>
          <div className="content-summary-wrapper">
            <div className="content-wrapper">
              <div className="tabs-container">
                <div className="tab-header">
                  {topMenus?.map((tab, index) => (
                    <div
                      key={index}
                      className={`${activeTab === index ? 'tab active' : 'tab'}`}
                      onClick={() => handleTabClick(index)}
                    >
                      <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}>
                        {tab.menu_icon}
                      </span>
                      <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                      {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero
                        className={activeTab === index ? "tab-badge active" : "tab-badge"} />}
                    </div>
                  ))}
                </div>
              </div>
              <div className="journal-content-details">
                {/* Summary Information */}
                {activeTab === 0 &&
                  <>
                    {documentEnabled === "N" &&
                      <div className="content-details-row approved-doc">
                        <span>{`${t('journal').toUpperCase()}: ${hdNo}`}</span>
                        <span>{`${t('bizUnit').toUpperCase()}: ${hdBizUnit?.label}`}</span>
                        <span>{`${t('status').toUpperCase()}: ${hdStatus}`}</span>
                      </div>}
                    {/* journal details */}
                    <ExpandableComponent
                      title={t('details').toUpperCase()}
                      subtitle={<span className={`status ${hdStatus}`}>{`${t('status').toUpperCase()} ${hdStatus}`}</span>}
                      defaultExpanded={true}
                    >
                      <div className="content-details-row">
                        <div className="content-details-left">
                          <div className="input-item-with-label">
                            <label htmlFor="hd_type" className="form-dropdown-label" style={{ width: "100px" }}>{t('type').toUpperCase()}</label>
                            <Select
                              ref={journalTypeRef}
                              id="hd_type"
                              name="hd_type"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="450px"
                              value={hdType}
                              onChange={(selectedOption) => setHdType(selectedOption)}
                              options={journalTypes}
                              isSearchable
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('type').toUpperCase()}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_biz_unit"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('bizUnit').toUpperCase()}
                              </label>
                              <Select
                                id="hd_biz_unit"
                                name="hd_biz_unit"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark"
                                    ? customSelectStyles_dark
                                    : customSelectStyles_light),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                width="170px"
                                value={hdBizUnit}
                                onChange={(selectedOption) => setHdBizUnit(selectedOption)}
                                options={branches}
                                isSearchable
                                isDisabled={documentEnabled === "N"}
                                placeholder={t('bizUnit').toUpperCase()}
                              />
                            </div>
                            <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                              <label
                                htmlFor="hd_ref_no"
                                className="form-dropdown-label"
                              >
                                {t('refNo').toUpperCase()}
                              </label>
                              <input
                                id="hd_ref_no"
                                name="hd_ref_no"
                                type="text"
                                placeholder={t('refNo').toUpperCase()}
                                value={hdRefNo}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => setHdRefNo(e.target.value)}
                                disabled={documentEnabled === "N"}
                              />
                            </div>
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_source"
                              className="form-dropdown-label" style={{ width: "100px" }}
                            >
                              {t('source').toUpperCase()}
                            </label>
                            <Select
                              id="hd_source"
                              name="hd_source"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="450px"
                              value={hdSource}
                              onChange={(selectedOption) => setHdSource(selectedOption)}
                              options={journalSources}
                              isSearchable
                              placeholder={t('source').toUpperCase()}
                              isDisabled={documentEnabled === "N"}
                            />
                          </div>
                        </div>
                        <div className="content-details-right">
                          <div className="input-item-with-label">
                            <label htmlFor="hd_no" className="form-dropdown-label">
                              {t('journalNo').toUpperCase()}
                            </label>
                            <input
                              id="hd_no"
                              name="hd_no"
                              type="text"
                              placeholder={t('journalNo').toUpperCase()}
                              value={hdNo}
                              disabled={!isDocumentNumberSetup}
                              className="form-input-item"
                              style={{ width: "200px" }}
                              onChange={(e) => setHdNo(e.target.value)}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_gl_date"
                              className="form-dropdown-label"
                            >
                              {t('glDate').toUpperCase()}
                            </label>
                            <input
                              ref={glDateRef}
                              id="hd_gl_date"
                              name="hd_gl_date"
                              type="date"
                              placeholder={t('glDate').toUpperCase()}
                              value={hdGlDate}
                              className="form-input-item"
                              style={{ width: "200px" }}
                              onChange={handleGlDateChange}
                              disabled={documentEnabled === "N"}
                            />
                          </div>
                          <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                            <label
                              htmlFor="hd_cur_code"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}
                            >
                              {t('currency').toUpperCase()}
                            </label>
                            <Select
                              id="hd_cur_code"
                              name="hd_cur_code"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark"
                                  ? customSelectStyles_dark
                                  : customSelectStyles_light),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              width="200px"
                              value={hdCurCode}
                              onChange={async (selectedOption) => {
                                try {
                                  if (selectedOption.value !== currentUser?.currency_code_xx) {
                                    setHdCurCode(selectedOption);

                                    const res = await newRequest.post("/glCurrencyRate/find", {
                                      rate_cur_code_fm: selectedOption.value,
                                      rate_cur_code_to: currentUser?.currency_code_xx,
                                      rate_date: hdGlDate,
                                    });
                                    if (!res.data || !res.data?.rate) {
                                      setHdCurCode({
                                        value: currentUser.currency_code_xx,
                                        label: currentUser.currency_code_xx,
                                      });
                                      setHdCurRate(1);
                                      setNotifyDialogTitle(t('note'));
                                      setNotifyDialogText(
                                        `Conversion Rate from <strong>${selectedOption.value
                                        } to ${currentUser.currency_code_xx
                                        } for date ${moment(hdGlDate).format(
                                          "DD-MMM-YYYY"
                                        )}</strong> NOT found. Currency will reset to <strong>${currentUser.currency_code_xx
                                        }</strong>`
                                      );
                                      setIsNotifyDialogOpen(true);
                                    } else {
                                      setHdCurRate(res.data.rate);
                                    }
                                  } else {
                                    setHdCurCode({
                                      value: currentUser?.currency_code_xx,
                                      label: currentUser?.currency_code_xx,
                                    });
                                    setHdCurRate(1);
                                  }
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={currencies}
                              isSearchable
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('currency').toUpperCase()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="content-details-row">
                        <div className="input-item-with-label"
                          style={{
                            display: "flex",
                            width: "100%",
                          }}>
                          <label
                            htmlFor="hd_narration"
                            className="form-dropdown-label"
                            style={{ width: "115px", alignSelf: "flex-start" }}
                          >
                            {t('narration').toUpperCase()}
                          </label>
                          <textarea
                            id="hd_narration"
                            name="hd_narration"
                            type="text"
                            placeholder={t('narration').toUpperCase()}
                            value={hdNarration}
                            row={5}
                            className="form-input-item"
                            style={{ width: "100%" }}
                            onChange={(e) => setHdNarration(e.target.value)}
                            disabled={documentEnabled === "N"}
                          />
                        </div>
                      </div>
                    </ExpandableComponent>
                    {/* end if receipt details */}
                    {/* receipt lines */}
                    <ExpandableComponent
                      title={t('lines').toUpperCase()}
                      subtitle={
                        journalDocId !== "new" &&
                        documentEnabled === "Y" &&
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={(e) => {
                            try {
                              setLedgerAction("addLine");
                              setIsLedgerDialogOpened(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          icon={<MdAdd />}
                          width={"35px"}
                          height={"35px"} />}
                      defaultExpanded={true}
                    >
                      <div className="lines-wrapper">
                        {journalDocId === "new" && (
                          <motion.div className="doc-not-saved"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            NEW JOURNAL. AFTER SAVING, YOU'LL BE ABLE TO PERFORM MORE ACTIONS
                          </motion.div>
                        )}
                        {journalDocId !== "new"
                          && (
                            <>
                              <motion.div
                                className="table-content"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                  <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableHead className="tablehead">
                                      <TableRow className="tablerow">
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                          #
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                          <span> {t('ledger').toUpperCase()}</span>
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "110px" }}>
                                          <span> {t('flag').toUpperCase()}</span>
                                        </TableCell>
                                        <TableCell className="table-cell right" style={{ maxWidth: "180px" }}>
                                          <span> {t('amount').toUpperCase()}</span>
                                        </TableCell>
                                        {currentUser?.currency_code_xx !== hdCurCode?.value &&
                                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                            <span>{t('base').toUpperCase()}</span>
                                          </TableCell>}
                                        {documentEnabled === "Y" &&
                                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                            <span> {t('action').toUpperCase()}</span>
                                          </TableCell>}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody className="tablebody">
                                      {slicedJournalLines?.map((row, index) => (
                                        <TableRow
                                          key={row._id}
                                          className={`${selectedJournalLine?._id === row._id ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedJournalLine(row)}
                                        >
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            <span className="sub-title">{currentPage * rowsPerPage + index + 1}</span>
                                          </TableCell>

                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <div className="tacc-desc">
                                              <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                <span className="tacc-desc__title">{`${row?.ln_mgl_code} - ${row?.mgl_name_xx}`}</span>
                                                {documentEnabled === "Y" && (
                                                  <CircularButton
                                                    currentTheme={currentTheme}
                                                    color="#4CAF50"
                                                    onClick={(e) => {
                                                      setSelectedJournalLine(row);
                                                      setMainLedgerType(row?.ln_mgl_sub_type);
                                                      setMainLedger({
                                                        ma_sub_type: row?.ln_mgl_sub_type,
                                                        value: row?.ln_mgl_code,
                                                        label: `${row?.mgl_name_xx} - [${row?.ln_mgl_code}]`
                                                      });

                                                      if (["Entity", "Account"].includes(row?.ln_mgl_sub_type)) {
                                                        setSubLedger({
                                                          value: row?.ln_sgl_code,
                                                          label: row?.sgl_name_xx
                                                        });
                                                      }

                                                      const drcrOption = drcrFlags.find(option => option.value === row?.ln_drcr_flag);
                                                      setFlag(drcrOption || null);
                                                      setFcAmount(row?.ln_amount_fc);
                                                      setLcAmount(row?.ln_amount_lc);
                                                      setLedgerAction("updateLine");
                                                      setIsLedgerDialogOpened(true);
                                                    }}
                                                    icon={<MdEdit />}
                                                    width={"30px"}
                                                    height={"30px"} />)}
                                              </div>
                                              <span className="tacc-desc__sub">{`${row?.ln_sgl_code || ""} - ${row?.sgl_name_xx || ""}`}</span>
                                              {row?.ln_narration && <span className="tacc-desc__note">{row?.ln_narration}</span>}
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ maxWidth: "110px" }}>
                                            <div className="input-item-with-label">
                                              {documentEnabled === "Y" ?
                                                <Select
                                                  id="ln_drcr_flag"
                                                  name="ln_drcr_flag"
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                      ...base,
                                                      zIndex: 9999,
                                                    })
                                                  }}
                                                  width="100px"
                                                  value={drcrFlags.find(option => option.value === row?.ln_drcr_flag) || null}
                                                  onChange={(selectedOption) => handleLineInputChange(selectedOption, row?._id, 'ln_drcr_flag')}
                                                  options={drcrFlags}
                                                  isDisabled={documentEnabled === "N"}
                                                />
                                                :
                                                <span className={`tacc-flag ${row?.ln_drcr_flag === "D" ? "d" : "c"}`}>
                                                  {row?.ln_drcr_flag}
                                                </span>
                                              }
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell right" style={{ maxWidth: "180px" }}>
                                            {documentEnabled === "Y" ?
                                              <div className="input-item-with-label">
                                                <input
                                                  id="ln_amount_fc"
                                                  name="ln_amount_fc"
                                                  value={row.ln_amount_fc}
                                                  onChange={(e) => handleLineInputChange(e, row._id, 'ln_amount_fc')}
                                                  onBlur={() => handleLineBlur(row._id, "ln_amount_fc")}
                                                  style={{ width: "100%", textAlign: "right" }}
                                                  className="form-input-item"
                                                />
                                              </div>
                                              : <h1 className='normal-title'>{numeral(row.ln_amount_fc).format("0,0.00")}</h1>}
                                          </TableCell>

                                          {currentUser?.currency_code_xx !== hdCurCode?.value &&
                                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                              <span>{numeral(row.ln_amount_lc).format("0,0.00")}</span>
                                            </TableCell>}

                                          {documentEnabled === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                              <CircularButton
                                                currentTheme={currentTheme}
                                                onClick={async () => {
                                                  try {
                                                    setIsProcessing(true);
                                                    const res = await newRequest.delete(`/glJournal/delLine/${row._id}`);
                                                    setIsProcessing(false);
                                                    if (res.data?.msg === "deleted") {
                                                      setJournalLines((prev) => prev.filter(param => param._id !== row._id));
                                                      showToast(t('deleted'), "success");
                                                    } else {
                                                      showToast(res.data?.text, "error");
                                                    }
                                                  } catch (error) {
                                                    console.log(error);
                                                  }
                                                }}
                                                color="#E53935"
                                                icon={<MdDelete />}
                                                width={"30px"}
                                                height={"30px"} />
                                            </TableCell>}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                  {journalLines?.length > rowsPerPage &&
                                    <TablePagination
                                      rowsPerPageOptions={[5]}
                                      rowsPerPage={rowsPerPage}
                                      onRowsPerPageChange={handleRowsPerPage}
                                      component="div"
                                      count={journalLines?.length}
                                      rows={journalLines}
                                      page={currentPage}
                                      onPageChange={handlePageChange}
                                    />}
                                </TableContainer>
                              </motion.div>
                            </>
                          )}
                      </div>
                    </ExpandableComponent>
                    {/* end of journal lines */}
                    {/* T-Account after posting document */}
                    {["Approved", "Cancelled"].includes(hdStatus) &&
                      <Taccount key={hdStatus} originalDocId={journalDocId} originalDocno={hdNo} originalDocType={"GL Journal"} endorsementIndex={0} />}
                  </>
                }
                {activeTab === 1 && <>
                  <motion.div
                    className="tabs-view-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="attachment">
                      <FileUploadComponent
                        documentNo={hdNo}
                        documentId={journalDocId}
                        documentType="Gl Journal"
                        fetchDocumentAttachments={fetchDocumentAttachments}
                        uploadFolder={`gl-journal/${journalDocId}`} />
                      <div className="attachment-files">
                        <AllFiles filesList={attachmentsData} />
                      </div>
                    </div>
                  </motion.div>
                </>}
                {activeTab === 2 &&
                  <motion.div
                    className="correspondence"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                  >
                    <Correspondence
                      correspondenceParams={{ fetch_type: "document", doc_id: journalDocId, doc_no: hdNo, doc_type: "Journal", entity_codes: [] }}
                      passedEmailData={{
                        // to: `${journalData?.client_email_xx}`,
                        // cc: `${currentUser?.usr_email}`,
                        // bcc: '',
                        // subject: `Journal No ${hdNo}`,
                        // show_attach: "Y",
                        // attached_urls: [],
                        // binary_docs: [],
                        // doc_no: hdNo,
                        // doc_type: "Journal",
                        // doc_id: journalDocId,
                        // entity_codes: [hdEntCode?.value],
                        // search_string: hdEntCode?.label?.props?.children[0] + "," + hdNo,
                        // carrierName: "",
                        // productName: "",
                        // clientName: hdEntCode?.label?.props?.children[0],
                        // riskNoteNo: hdNo,
                        // daysToRenewal: 0,
                        // expiryDate: "",
                        // insuredName: hdEntCode?.label?.props?.children[0],
                        // outstandingPremium: 0,
                        // policyCurrency: hdCurCode?.value,
                        // policyNumber: hdNo,
                        // policyPremium: "",
                        // policyPremiumTotal: "",
                        // policySumInsured: "",
                        // policyFromDate: "",
                        // policyToDate: "",
                        // tpt_category: []
                      }} />
                  </motion.div>
                }
                {activeTab === 3 &&
                  <AllDocsNote
                    docId={journalData._id}
                    docType="Journal"
                    noteType={"Normal"}
                  />
                }
              </div>
            </div>
            <div className="journal-summary-wrapper">
              {journalDocId !== "new" &&
                hdStatus === "New" &&
                <div className="panel-card void"
                  onClick={() => {
                    try {
                      setObjectToAction({
                        object_id: journalData._id,
                        action_text: `Do you want to Void ${hdNo}?<br/><br/>${t('thisActionIsIrrevasible')}`
                      });
                      setConfirmDialogAction("voidJournal");
                      setIsConfirmDialogOpen(true);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <div className="panel-card__header">
                    <div className="panel-card__titleRow">
                      <h1 className="panel-card__title">{t("voidJournal").toUpperCase()}</h1>
                    </div>
                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("voidJournalDesc").toUpperCase()}</span>
                      </div>
                    </div>
                  </div>
                </div>}

              <div className="panel-card" style={{ padding: "10px" }}>
                <WorkedOnBy name={journalData?.updated_by_name_xx || currentUser?.usr_full_name} photoUrl={journalData?.updated_by_photo_url_xx} time_ago_xx={journalData?.time_ago_xx} />
              </div>
              <div className="summary-content">
                {hdCurCode?.value !== currentUser?.currency_code_xx && (
                  <div
                    className="input-item-with-label"
                    style={{ alignSelf: "flex-end", margin: "0px 5px 5px 0px" }}
                  >
                    <label
                      htmlFor="hd_cur_rate"
                      className="form-dropdown-label"
                    >
                      {t('rate').toUpperCase()}
                    </label>
                    <input
                      id="hd_cur_rate"
                      name="hd_cur_rate"
                      type="number"
                      placeholder="0.00"
                      value={hdCurRate}
                      className="form-input-item"
                      style={{
                        width: "150px",
                        textAlign: "right",
                      }}
                      onChange={(e) => setHdCurRate(e.target.value)}
                      disabled={documentEnabled === "N"}
                      onBlur={handleCurRateBlur}
                    />
                  </div>
                )}
                <motion.div
                  className="summary-view"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                  {/* ===================== SUMMARY CARD ===================== */}
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>

                        {currentUser?.currency_code_xx !== hdCurCode?.value && (
                          <CustomButtonSmall
                            style={{ display: "flex" }}
                            onClick={() => setFiguresToShow((p) => (p === "org" ? "base" : "org"))}
                          >
                            {figuresToShow === "org"
                              ? `${t('view')} ${currentUser?.currency_code_xx}`
                              : `${t('view')} ${hdCurCode?.value}`}
                          </CustomButtonSmall>
                        )}

                        <span className="panel-card__currency">
                          {figuresToShow === "org" ? hdCurCode?.value : currentUser?.currency_code_xx}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>

                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("totalDebit").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? totalDebitFc
                              : totalDebitLc
                          ).format("0,0.00")}
                        </span>
                      </div>
                      <div className="kv-row">
                        <span className="kv-key">{t("totalCredit").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? totalCreditFc
                              : totalCreditLc
                          ).format("0,0.00")}
                        </span>
                      </div>
                      <div
                        className={`pill-row ${controlAmountFc !== 0
                          ? "pill-row--danger"
                          : "pill-row--success"
                          }`}
                      >
                        <span className="pill-label">{t("control").toUpperCase()}</span>
                        <span className="pill-value">
                          {numeral(
                            figuresToShow === "org"
                              ? controlAmountFc
                              : controlAmountLc
                          ).format("0,0.00")}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("timeline").toUpperCase()}</h1>
                      </div>
                      {/* <div className="panel-card__divider" /> */}
                      <div className="timeline-root">
                        {traceData.map((item) => (
                          <div key={item?._id} className="timeline-item">
                            <div className="timeline-separator">
                              <div className="timeline-dot"></div>
                              <div className="timeline-connector" />
                            </div>
                            <div className="timeline-content">
                              <div className="timeline-navbar">
                                <div className="avatar-container">
                                  {item?.updated_by_photo_url_xx ?
                                    <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" />
                                    : <InitialsAvatar
                                      name={item?.updated_by_name_xx}
                                      size={30}
                                      currentTheme={currentTheme}
                                    />}
                                  <span className="username">{item?.updated_by_name_xx}</span>
                                </div>
                                <span className="time-ago">{item?.time_ago_xx}</span>
                              </div>
                              <div className="remarks">
                                {item?.trc_remarks}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
          <Collaborator
            open={isCollabOpen}
            docType={"Journal"}
            docNo={hdNo}
            docId={journalData?._id}
            currentTheme={currentTheme}
            onClose={closeCollab}
            rightOffset={collabRightOffset}
            currentUser={currentUser}
          />
        </div>
      )}
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-content">
              <ValidationMessages
                messageData={validationMessagesResult}
                onClose={() => setValidationMsgDialog(false)}
                onFix={(row) => {/* focus field / navigate */ }}
                onRemind={() => setValidationMsgDialog(false)}
                onSupport={() => navigate("/support")}
              />
            </div>
          </div>
        </motion.div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            endIcon={<MdClose />}
            onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}
          </CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objectToAction.action_text) }} />
        }
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>)}
      {isLedgerDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{ledgerAction === "addLine" ? t('addLine') : t('updateLine')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setIsLedgerDialogOpened(false)}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="control-layout">
                <hr className="separator-h" />

                <div className="control-split">
                  <div className="control-col left">
                    <label className="form-dropdown-label">
                      {t('debit').toUpperCase()}
                    </label>
                    <span className="control-value">
                      {numeral(totalDebitFc).format('0,0.00')}
                    </span>
                  </div>

                  <div className="vertical-divider" />

                  <div className="control-col right">
                    <label className="form-dropdown-label">
                      {t('credit').toUpperCase()}
                    </label>
                    <span className="control-value">
                      {numeral(totalCreditFc).format('0,0.00')}
                    </span>
                  </div>
                </div>

                <hr className="separator-h" />

                <div className="control-center">
                  <label className="form-dropdown-label">
                    {t('controlAmount').toUpperCase()}
                  </label>
                  <span
                    className={`control-value ${totalDebitFc !== totalCreditFc ? "error" : "success"
                      }`}
                  >
                    {numeral(totalDebitFc - totalCreditFc).format('0,0.00')}
                  </span>
                </div>

                <hr className="separator-h" />
              </div>

              <div className="input-item-with-label">
                <label
                  htmlFor="mainLedger"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}>
                  {t('main').toUpperCase()}
                </label>
                <AsyncSelect
                  ref={mainLedgerRef}
                  id="mainLedger"
                  name="mainLedger"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="450px"
                  value={mainLedger}
                  onChange={(selectedOption) => {
                    try {
                      setMainLedger(selectedOption);
                      setMainLedgerType(selectedOption?.ma_sub_type);
                      setSubLedger(null);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  loadOptions={(inputValue, callback) => fetchMainLedgers(inputValue, callback, [])}
                  isSearchable
                  isClearable
                  isDisabled={documentEnabled === "N"}
                  placeholder={t('main')}
                  noOptionsMessage={() => t('typeToSearch', { param1: 2 })} />
              </div>
              {mainLedgerType && <span className="sub-title soft" style={{ paddingLeft: "100px", fontSize: "10px" }}>{`${t('subType')}: ${mainLedgerType}`}</span>}
              {["Account", "Entity"].includes(mainLedgerType) &&
                <div className="input-item-with-label">
                  <label htmlFor="subLedger" className="form-dropdown-label" style={{ width: "100px" }}>{t('sub').toUpperCase()}</label>
                  {mainLedgerType === "Account" ?
                    <AsyncSelect
                      id="subLedger"
                      name="subLedger"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="450px"
                      value={subLedger}
                      onChange={(selectedOption) => setSubLedger(selectedOption)}
                      loadOptions={(inputValue, callback) => fetchSubLedgers(inputValue, callback, mainLedger?.value)}
                      isSearchable
                      isClearable
                      isDisabled={documentEnabled === "N"}
                      placeholder={t('sub')}
                      noOptionsMessage={() => t('typeToSearch', { param1: 2 })} />
                    :
                    <AsyncSelect
                      id="entity"
                      name="entity"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="450px"
                      value={subLedger}
                      onChange={(selectedOption) => setSubLedger(selectedOption)}
                      loadOptions={fetchClientsBySearch}
                      isSearchable
                      isClearable
                      isDisabled={documentEnabled === "N"}
                      placeholder={t('entity')}
                      noOptionsMessage={() => t('typeToSearch', { param1: 2 })}
                    />}
                </div>}
              <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                <div className="input-item-with-label">
                  <label htmlFor="flag" className="form-dropdown-label" style={{ width: "100px" }}>{t('flag').toUpperCase()}</label>
                  <Select
                    id="flag"
                    name="flag"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="100px"
                    value={flag}
                    placeholder={t('flag')}
                    onChange={(selectedOption) => setFlag(selectedOption)}
                    options={drcrFlags}
                  />
                </div>
                <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                  <label htmlFor="flag" className="form-dropdown-label" >{`${t('amount').toUpperCase()} [${hdCurCode?.value}]`}</label>
                  <input
                    id="fcAmount"
                    name="fcAmount"
                    type="text"
                    placeholder="0.00"
                    value={fcAmount}
                    onChange={(e) => setFcAmount(e.target.value)}
                    onBlur={(e) => {
                      try {
                        if (e.target.value) {
                          const strippedValue = e.target.value.replace(/,/g, "");
                          if (isNaN(strippedValue)) {
                            setNotifyDialogTitle("Error!");
                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                            setIsNotifyDialogOpen(true);
                            return;
                          }
                          setFcAmount(formatAmountsToDecimals(strippedValue, 2));
                          const lcAmount = Number(parseFloat(strippedValue * hdCurRate).toFixed(4));
                          setLcAmount(lcAmount);
                        }
                      } catch (error) {
                        console.log(error)
                      }
                    }}
                    style={{ width: "200px", textAlign: "right" }}
                    className="form-input-item"
                  />
                </div>
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#1976D2"
                endIcon={<IoCheckmarkDoneSharp />}
                width={"200px"}
                onClick={async () => {
                  try {

                    if (!mainLedger?.value) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(t('mandatoryParam1', { param1: t('mainLedger') }));
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (["Account", "Entity"].includes(mainLedgerType) && !subLedger?.value) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(t('mandatoryParam1', { param1: t('subLedger') }));
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (!flag?.value) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(t('mandatoryParam1', { param1: t('drcrFlag') }));
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (parseFloat(formatStringToNumberV2(fcAmount || 0)) < 1) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(t('amountCannotBeZero'));
                      setIsNotifyDialogOpen(true);
                      return;
                    }


                    if (ledgerAction === "addLine") {
                      setIsProcessing(true);
                      setIsProcessingTitle(t('addingLine'));
                      const res = await newRequest.post(`/glJournal/addLine/${journalDocId}`,
                        {
                          ln_mgl_code: mainLedger?.value,
                          ln_mgl_sub_type: mainLedgerType,
                          ln_sgl_code: subLedger?.value,
                          ln_drcr_flag: flag?.value,
                          ln_amount_fc: parseFloat(formatStringToNumberV2(fcAmount || 0)) || 0,
                          ln_amount_lc: parseFloat(formatStringToNumberV2(lcAmount || 0)) || 0,
                        }
                      );
                      setIsProcessing(false);
                      if (res.data?.msg === "added") {
                        setJournalLines((prevData) => [...prevData, {
                          ...res.data?.doc,
                          ln_amount_fc: formatAmountsToDecimals(res.data?.doc?.ln_amount_fc || 0),
                          ln_amount_lc: formatAmountsToDecimals(res.data?.doc?.ln_amount_lc || 0),
                        }]);
                        setMainLedger(null);
                        setMainLedgerType(null);
                        setSubLedger(null);
                        setFlag(null);
                        setFcAmount("");
                        setLcAmount("");
                        if (mainLedgerRef.current) {
                          mainLedgerRef.current.focus();
                        }
                        showToast(t('added'), "success");
                      } else {
                        showToast(res.data?.text, "error");
                      }
                    } else if (ledgerAction === "updateLine") {
                      setIsProcessing(true);
                      setIsProcessingTitle(t('updatingLine', { param1: mainLedger?.label }));
                      const res = await newRequest.put(`/glJournal/updLine/${selectedJournalLine?._id}`,
                        {
                          ln_mgl_code: mainLedger?.value,
                          ln_mgl_sub_type: mainLedgerType,
                          ln_sgl_code: subLedger?.value,
                          ln_drcr_flag: flag?.value,
                          ln_amount_fc: parseFloat(formatStringToNumberV2(fcAmount || 0)) || 0,
                          ln_amount_lc: parseFloat(formatStringToNumberV2(lcAmount || 0)) || 0,
                        }
                      );
                      setIsProcessing(false);
                      if (res.data?.msg === "updated") {
                        const updatedDoc = res.data?.doc;
                        setJournalLines((prev) => {
                          return prev.map((param) =>
                            param._id === updatedDoc._id ? {
                              ...updatedDoc,
                              ln_amount_fc: formatAmountsToDecimals(res.data?.doc?.ln_amount_fc || 0),
                              ln_amount_lc: formatAmountsToDecimals(res.data?.doc?.ln_amount_lc || 0),
                            } : param
                          );
                        });
                        setMainLedger(null);
                        setMainLedgerType(null);
                        setSubLedger(null);
                        setFlag(null);
                        setFcAmount("");
                        setLcAmount("");
                        showToast(t('updated'), "success");
                        setIsLedgerDialogOpened(false);
                      } else {
                        showToast(res.data?.text, "error");
                      }
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}>
                {ledgerAction === "addLine" ? t('addLine') : t('updateLine')}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>)}

      {/* email component */}
      {emailDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('email').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setReportsDialogOpen(false)}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroup={journalData?.report_group}
                documentData={{
                  docNo: hdNo,
                  docType: "Gl Journal",
                  docId: journalDocId,
                  journal_docid: journalDocId,
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isConfettiActive && <Confetti />}
    </motion.div>
  );
};


export default GlJournal;
